module.exports = __webpack_public_path__ + "bbf9e943fa392ec342410e04efd739a9.ogg";